import * as React from 'react';
import {Query, Mutation} from 'react-apollo';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import {SaveButton} from 'shells/button/save-button/save-button';
import {EmailEditor} from 'shells/email-editor/email-editor';
import {RetryableError} from 'shells/flash-banner/retryable-error';

import type {
    GetUserEmailSignature as GetUserEmailSignatureQuery,
    setUserEmailSignature as setUserEmailSignatureMutation,
    setUserEmailSignatureVariables as setUserEmailSignatureMutationVariables,
} from 'nutshell-graphql-types';

import SET_USER_EMAIL_SIGNATURE from './graphql/mutations/set-user-email-signature.graphql';
import GET_USER_EMAIL_SIGNATURE from './graphql/queries/get-user-email-signature.graphql';

import styles from './email-signature-container.module.css';

class EmailSignatureQuery extends Query<GetUserEmailSignatureQuery, Record<any, any>> {}

class SetEmailSignatureMutation extends Mutation<
    setUserEmailSignatureMutation,
    setUserEmailSignatureMutationVariables
> {}

export class EmailSignatureContainer extends React.PureComponent<{
    disabled: boolean;
}> {
    static defaultProps = {
        disabled: false,
    };

    render() {
        return (
            <EmailSignatureQuery query={GET_USER_EMAIL_SIGNATURE}>
                {({data, loading, refetch, error}) => {
                    if (loading) {
                        return null;
                    }

                    if (error || !(data && data.loggedInUser)) {
                        return (
                            <RetryableError
                                message='There was a problem getting your email signature. Please retry or contact
                support.'
                                // @ts-expect-error
                                details={safelyGetGraphQLErrorMessage(error)}
                                retry={refetch}
                            />
                        );
                    }

                    return (
                        <EmailSignatureContainerComponent
                            signature={data.loggedInUser.emailSignature}
                            disabled={this.props.disabled}
                        />
                    );
                }}
            </EmailSignatureQuery>
        );
    }
}

type Props = {
    signature: string | null | undefined;
    disabled: boolean;
};

type State = {
    value: string;
    isSaving: boolean;
};

class EmailSignatureContainerComponent extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            value: props.signature || '',
            isSaving: false,
        };
    }

    render() {
        return (
            <SetEmailSignatureMutation mutation={SET_USER_EMAIL_SIGNATURE}>
                {(setSignature) => {
                    return (
                        <div className={styles['email-signature-container']}>
                            <div className={styles['contents-container']}>
                                <EmailEditor
                                    onChange={this.handleChange}
                                    value={this.state.value}
                                />
                            </div>
                            <div className={styles['save-button-container']}>
                                <SaveButton
                                    // @ts-expect-error
                                    onClick={() => {
                                        this.setState({isSaving: true});

                                        setSignature({
                                            variables: {emailSignature: this.state.value},
                                        }).then(() => {
                                            this.setState({
                                                isSaving: false,
                                            });
                                        });
                                    }}
                                    resetOnComplete={true}
                                    isSaving={this.state.isSaving}
                                    disabled={this.props.disabled}
                                />
                            </div>
                        </div>
                    );
                }}
            </SetEmailSignatureMutation>
        );
    }

    handleChange = (newVal: string) => {
        this.setState({value: newVal});
    };
}
